export default '$$material';